import { Link } from 'react-router-dom';
import './App.css';

const Home = () => {
    return(
        <>
        <div id="dynamicLinks">
            <Link to="/Ai">
                <div className="main-child">
                    <div className="img-view">
                      <img src="ai.jpeg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Artificial Intelligence - AI</p>
                    </div>
                </div>
            </Link>
        </div>
        <div id="dynamicLinks">
            <Link to="/Web_projects">
                <div className="main-child">
                    <div className="img-view">
                      <img src="web.jpeg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Web-2.0 Project</p>
                    </div>
                </div>
            </Link>
        </div>
        <div id="dynamicLinks">
            <Link to="/Block_projects">
                <div className="main-child">
                    <div className="img-view">
                      <img src="block.jpeg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Web-3.0 Project</p>
                    </div>
                </div>
            </Link>
        </div>
         <div id="dynamicLinks">
            <Link to="/Hackathon">
                <div className="main-child">
                    <div className="img-view">
                      <img src="hackathon.jpg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Hackathon</p>
                    </div>
                </div>
            </Link>
        </div>
        <div id="dynamicLinks">
            <Link to="/App_projects">
                <div className="main-child">
                    <div className="img-view">
                      <img src="android.jpeg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Android Project - App</p>
                    </div>
                </div>
            </Link>
        </div>
        <div id="dynamicLinks">
            <Link to="/VR_projects">
                <div className="main-child">
                    <div className="img-view">
                      <img src="vr.jpeg" alt="web"></img>
                    </div>
                    <div className="text">
                      <p>Virtual Reality - VR</p>
                    </div>
                </div>
            </Link>
        </div>
        <div id="dynamicLinks">
            <a href="https://github.com/Prince200510/Python" target="_blank" rel="noopener noreferrer">
                <div className="main-child">
                  <div className="img-view">
                    <img src="python.jpeg" alt="web" />
                  </div>
                  <div className="text">
                    <p>Python Projects</p>
                  </div>
                </div>
            </a>
        </div>
        
        </>
    )
};

export default Home;